import { cookie } from '@tencent/ppd-base-libs';
import { jumpUrl } from './jump-page';

// 跳转绑卡首页
const BINDCARD_INDEX = '//hkwallet.moneydata.hk/fcgi-bin/app/ewallet_bindcard/ewallet_index.fcgi';
// 跳转绑卡列表页-海外
const BINDCARD_LIST_OVERSEA = '//hkwallet.moneydata.hk/fcgi-bin/app/ewallet_bindcard/oversea_banklist.fcgi';
// 跳转绑卡列表页
const BINDCARD_LIST = '//hkwallet.moneydata.hk/fcgi-bin/app/ewallet_bindcard/ewallet_banklist.fcgi';

/**
 * 跳转绑卡的场景场景
 */
export enum BindFromScene {
  /** 基础钱包 */
  HKwallet = 1,
  /** 支付中绑卡 */
  PAYING = 2,
  /** 营销活动 */
  PROM = 3
};

/**
 * 跳转到通过绑卡首页
 * @param scene
 * @param options
 */
export function goBindCardIndex(adtag: string, scene = BindFromScene.HKwallet) {
  jumpUrl(BINDCARD_INDEX, {
    adtag,
    params: {
      scene,
    },
  });
}

/**
 * 直接跳转到通过绑卡 addCard 页面
 * @param adtag
 * @param params
 */
export function goBindCardAddCardPage(adtag: string, scene = BindFromScene.HKwallet) {
  jumpUrl(BINDCARD_INDEX, {
    adtag,
    params: {
      page: 'CreditNum',
      scene,
    },
  });
}

/**
 * 跳转银行卡列表页
 */
export function goBanlistIndex(adtag: string, scene = BindFromScene.HKwallet) {
  const oversea = cookie.get('oversea');
  let url: string;
  let paramObj: Record<string, any>;
  // 如果是海外
  if (oversea) {
    url = BINDCARD_LIST_OVERSEA;
    paramObj = {
      hkSkey: oversea,
    };
  } else {
    url = BINDCARD_LIST;
    paramObj = {
      t: new Date().getTime(),
    };
  }
  jumpUrl(url, {
    adtag,
    params: {
      scene,
      ...paramObj,
    },
  });
}


